const jhsenglishLanguageQuestions = [
  {
    question: "Which of the following is an example of formal language?",
    options: [
      "What's up?",
      "Hey, you!",
      "How do you do?",
      "Yo, bro!"
    ],
    answer: "How do you do?"
  },
  
  {
  question: "Choose the correct sentence:",
  options: [
    "She go to school every day.",
    "She goes to school every day.",
    "She going to school every day.",
    "She gone to school every day."
  ],
  answer: "She goes to school every day."
},
{
  question: "Fill in the blank: He ____ playing football now.",
  options: ["is", "are", "am", "be"],
  answer: "is"
},
{
  question: "Choose the correct article: She bought ___ apple.",
  options: ["a", "an", "the", "some"],
  answer: "an"
},
{
  question: "Choose the correct preposition: He is afraid ___ dogs.",
  options: ["of", "on", "at", "with"],
  answer: "of"
},
{
  question: "Identify the incorrect sentence:",
  options: [
    "They are going home.",
    "She have finished her work.",
    "We are happy.",
    "He is reading."
  ],
  answer: "She have finished her work."
},
{
  question: "Choose the correct form: Each of the boys ____ present.",
  options: ["is", "are", "were", "have"],
  answer: "is"
},
{
  question: "Select the correct spelling:",
  options: ["accomodation", "accommodation", "acommodation", "acomodation"],
  answer: "accommodation"
},
{
  question: "Choose the correct word: ____ going to the market.",
  options: ["Their", "There", "They're", "Them"],
  answer: "They're"
},
{
  question: "Choose the correct tense: She ____ her homework before dinner.",
  options: ["has done", "have done", "doing", "do"],
  answer: "has done"
},
{
  question: "Which sentence is correct?",
  options: [
    "He don't like food.",
    "He doesn't like food.",
    "He not like food.",
    "He didn't likes food."
  ],
  answer: "He doesn't like food."
},
{
  question: "Choose the correct preposition: The book is ___ the table.",
  options: ["on", "in", "at", "by"],
  answer: "on"
},
{
  question: "Select the correct sentence:",
  options: [
    "She can sings well.",
    "She can sing well.",
    "She singing well.",
    "She sung well."
  ],
  answer: "She can sing well."
},
{
  question: "Fill in the blank: There ____ many students in the class.",
  options: ["are", "is", "was", "be"],
  answer: "are"
},
{
  question: "Choose the correct word: This is ____ book.",
  options: ["my", "mine", "me", "I"],
  answer: "my"
},
{
  question: "Identify the error:",
  options: [
    "I am going home.",
    "She is cooking.",
    "He do his homework.",
    "We are ready."
  ],
  answer: "He do his homework."
},
{
  question: "Choose the correct article: ___ sun rises in the east.",
  options: ["A", "An", "The", "Some"],
  answer: "The"
},
{
  question: "Select the correct tense: They ____ football yesterday.",
  options: ["played", "play", "playing", "plays"],
  answer: "played"
},
{
  question: "Choose the correct word: She is taller ____ her sister.",
  options: ["than", "then", "that", "those"],
  answer: "than"
},
{
  question: "Which sentence is correct?",
  options: [
    "We was happy.",
    "We were happy.",
    "We is happy.",
    "We be happy."
  ],
  answer: "We were happy."
},
{
  question: "Choose the correct form: I ____ seen that movie before.",
  options: ["have", "has", "had", "having"],
  answer: "have"
},
{
  question: "Choose the correct sentence:",
  options: [
    "She did not went to school.",
    "She did not go to school.",
    "She did not going to school.",
    "She did not goes to school."
  ],
  answer: "She did not go to school."
},
{
  question: "Fill in the blank: If I ____ you, I would study harder.",
  options: ["was", "were", "am", "be"],
  answer: "were"
},
{
  question: "Choose the correct word: I saw ____ at the market.",
  options: ["them", "they", "their", "theirs"],
  answer: "them"
},
{
  question: "Which sentence is correct?",
  options: [
    "He is more taller than me.",
    "He is taller than me.",
    "He is most tallest than me.",
    "He taller than me."
  ],
  answer: "He is taller than me."
},
{
  question: "Choose the correct spelling:",
  options: ["recieve", "receive", "receeve", "receve"],
  answer: "receive"
},
{
  question: "Choose the correct preposition: She is interested ____ music.",
  options: ["in", "on", "at", "for"],
  answer: "in"
},
{
  question: "Identify the incorrect sentence:",
  options: [
    "They have eaten already.",
    "She has finished her work.",
    "He have gone home.",
    "We have seen it."
  ],
  answer: "He have gone home."
},
{
  question: "Choose the correct word: ____ house is very big.",
  options: ["Their", "There", "They're", "Them"],
  answer: "Their"
},
{
  question: "Fill in the blank: The teacher ____ teaching now.",
  options: ["is", "are", "am", "be"],
  answer: "is"
},
{
  question: "Choose the correct form: Neither John nor Mary ____ coming.",
  options: ["is", "are", "were", "have"],
  answer: "is"
},
{
  question: "What is the meaning of the idiom 'once in a blue moon'?",
  options: [
    "Very often",
    "Rarely",
    "Every day",
    "Never"
  ],
  answer: "Rarely"
},
{
  question: "Choose the correct sentence:",
  options: [
    "I prefer tea than coffee.",
    "I prefer tea to coffee.",
    "I prefer tea over coffee than.",
    "I prefer tea more than coffee to."
  ],
  answer: "I prefer tea to coffee."
},
{
  question: "Select the correct tense: She ____ her work already.",
  options: ["has finished", "have finished", "finished", "finishing"],
  answer: "has finished"
},
{
  question: "Choose the correct word: This bag is ____.",
  options: ["mine", "my", "me", "I"],
  answer: "mine"
},
{
  question: "Identify the error:",
  options: [
    "She is very happy.",
    "They are playing football.",
    "He don't understand.",
    "We are learning."
  ],
  answer: "He don't understand."
},
{
  question: "Choose the correct preposition: He is good ____ mathematics.",
  options: ["at", "in", "on", "with"],
  answer: "at"
},
{
  question: "What is the opposite of 'generous'?",
  options: ["Stingy", "Kind", "Happy", "Brave"],
  answer: "Stingy"
},
{
  question: "Choose the correct word: ____ is raining heavily.",
  options: ["It", "He", "She", "They"],
  answer: "It"
},
{
  question: "Fill in the blank: She ____ to Accra last week.",
  options: ["went", "go", "gone", "going"],
  answer: "went"
},
{
  question: "What does the idiom 'break the ice' mean?",
  options: [
    "To break something",
    "To start a conversation",
    "To end a discussion",
    "To get angry"
  ],
  answer: "To start a conversation"
},
{
  question: "Identify the incorrect sentence:",
  options: [
    "She is singing beautifully.",
    "They was playing football.",
    "I am reading a book.",
    "We are learning English."
  ],
  answer: "They was playing football."
},
{
  question: "Choose the correct sentence:",
  options: [
    "He did not wrote the letter.",
    "He did not write the letter.",
    "He did not writing the letter.",
    "He did not writes the letter."
  ],
  answer: "He did not write the letter."
},
{
  question: "Identify the error:",
  options: [
    "She has eaten already.",
    "They have finished their work.",
    "He have completed the task.",
    "We have seen it."
  ],
  answer: "He have completed the task."
},
{
  question: "Choose the correct sentence:",
  options: [
    "I am going to home.",
    "I am going home.",
    "I am going to the home.",
    "I am go home."
  ],
  answer: "I am going home."
},
{
  question: "Identify the incorrect sentence:",
  options: [
    "She enjoys reading books.",
    "He enjoy reading books.",
    "They enjoy reading books.",
    "We enjoy reading books."
  ],
  answer: "He enjoy reading books."
},
{
  question: "Choose the correct sentence:",
  options: [
    "She can to swim.",
    "She can swims.",
    "She can swim.",
    "She can swimming."
  ],
  answer: "She can swim."
},
{
  question: "Identify the error:",
  options: [
    "The boy is very tall.",
    "The girls are playing.",
    "The dog bark loudly.",
    "The teacher is teaching."
  ],
  answer: "The dog bark loudly."
},
{
  question: "Choose the correct sentence:",
  options: [
    "He is married with her.",
    "He is married to her.",
    "He is married on her.",
    "He is married at her."
  ],
  answer: "He is married to her."
},
{
  question: "Identify the incorrect sentence:",
  options: [
    "We were happy yesterday.",
    "She was absent yesterday.",
    "They was present yesterday.",
    "He was late yesterday."
  ],
  answer: "They was present yesterday."
},
{
  question: "Choose the correct sentence:",
  options: [
    "She is used to wake up early.",
    "She is used to waking up early.",
    "She is used wake up early.",
    "She is used woke up early."
  ],
  answer: "She is used to waking up early."
},
{
  question: "Identify the error:",
  options: [
    "I have done my homework.",
    "She has completed her work.",
    "They has finished their work.",
    "We have eaten already."
  ],
  answer: "They has finished their work."
},
{
  question: "Choose the correct sentence:",
  options: [
    "He is good in football.",
    "He is good at football.",
    "He is good on football.",
    "He is good for football."
  ],
  answer: "He is good at football."
},
{
  question: "Identify the incorrect sentence:",
  options: [
    "The child is sleeping.",
    "The children are sleeping.",
    "The children is sleeping.",
    "The boy is sleeping."
  ],
  answer: "The children is sleeping."
},
{
  question: "Choose the correct sentence:",
  options: [
    "She is afraid from dogs.",
    "She is afraid of dogs.",
    "She is afraid with dogs.",
    "She is afraid at dogs."
  ],
  answer: "She is afraid of dogs."
},
{
  question: "Identify the error:",
  options: [
    "I saw him yesterday.",
    "She saw me yesterday.",
    "They saw we yesterday.",
    "We saw them yesterday."
  ],
  answer: "They saw we yesterday."
},
{
  question: "Choose the correct sentence:",
  options: [
    "He asked me where was I going.",
    "He asked me where I was going.",
    "He asked me where I am going.",
    "He asked me where going I was."
  ],
  answer: "He asked me where I was going."
},
{
  question: "Identify the incorrect sentence:",
  options: [
    "She speaks English well.",
    "He speaks English well.",
    "They speaks English well.",
    "We speak English well."
  ],
  answer: "They speaks English well."
},
{
  question: "Choose the correct sentence:",
  options: [
    "She is taller than him.",
    "She is more taller than him.",
    "She is tallest than him.",
    "She taller than him."
  ],
  answer: "She is taller than him."
},
{
  question: "Identify the error:",
  options: [
    "I am very tired.",
    "She is very hungry.",
    "They is very happy.",
    "We are very excited."
  ],
  answer: "They is very happy."
},
{
  question: "Choose the correct sentence:",
  options: [
    "He is interested on music.",
    "He is interested in music.",
    "He is interested at music.",
    "He is interested for music."
  ],
  answer: "He is interested in music."
},
{
  question: "Read the passage: 'Kofi woke up early to prepare for school. He studied his notes before leaving.' Why did Kofi wake up early?",
  options: [
    "To play",
    "To study",
    "To sleep",
    "To travel"
  ],
  answer: "To study"
},
{
  question: "From the passage above, what can you say about Kofi?",
  options: [
    "He is lazy",
    "He is hardworking",
    "He is careless",
    "He is weak"
  ],
  answer: "He is hardworking"
},
{
  question: "Read: 'The weather was very hot, so Ama stayed indoors.' Why did Ama stay indoors?",
  options: [
    "Because she was tired",
    "Because it was raining",
    "Because it was hot",
    "Because she was sick"
  ],
  answer: "Because it was hot"
},
{
  question: "What is the meaning of the word 'rapid'?",
  options: [
    "Slow",
    "Fast",
    "Weak",
    "Small"
  ],
  answer: "Fast"
},
{
  question: "Choose the synonym of 'happy':",
  options: ["Sad", "Joyful", "Angry", "Tired"],
  answer: "Joyful"
},
{
  question: "Choose the antonym of 'strong':",
  options: ["Powerful", "Weak", "Big", "Tall"],
  answer: "Weak"
},
{
  question: "Read: 'The boy was exhausted after running.' What does 'exhausted' mean?",
  options: [
    "Very tired",
    "Very happy",
    "Very angry",
    "Very fast"
  ],
  answer: "Very tired"
},
{
  question: "Choose the correct meaning of 'generous':",
  options: [
    "Kind and giving",
    "Selfish",
    "Angry",
    "Lazy"
  ],
  answer: "Kind and giving"
},
{
  question: "Choose the synonym of 'big':",
  options: ["Small", "Large", "Tiny", "Short"],
  answer: "Large"
},
{
  question: "Choose the antonym of 'early':",
  options: ["Late", "Fast", "Quick", "Soon"],
  answer: "Late"
},
{
  question: "Read: 'The farmer worked hard to get a good harvest.' What is the main idea?",
  options: [
    "The farmer was lazy",
    "Hard work leads to success",
    "Farming is easy",
    "Harvesting is difficult"
  ],
  answer: "Hard work leads to success"
},
{
  question: "What is the meaning of 'brave'?",
  options: [
    "Fearless",
    "Afraid",
    "Weak",
    "Lazy"
  ],
  answer: "Fearless"
},
{
  question: "Choose the antonym of 'clean':",
  options: ["Dirty", "Neat", "Bright", "Fresh"],
  answer: "Dirty"
},
{
  question: "Choose the synonym of 'quick':",
  options: ["Slow", "Fast", "Late", "Weak"],
  answer: "Fast"
},
{
  question: "Read: 'She studied hard and passed the exam.' What can you infer?",
  options: [
    "She failed",
    "Hard work leads to success",
    "She was lucky",
    "She did not study"
  ],
  answer: "Hard work leads to success"
},
{
  question: "What does the word 'ancient' mean?",
  options: [
    "Modern",
    "Very old",
    "New",
    "Young"
  ],
  answer: "Very old"
},
{
  question: "Choose the synonym of 'angry':",
  options: ["Happy", "Furious", "Calm", "Kind"],
  answer: "Furious"
},
{
  question: "Choose the antonym of 'rich':",
  options: ["Wealthy", "Poor", "Strong", "Kind"],
  answer: "Poor"
},
{
  question: "Read: 'The teacher explained the lesson clearly.' What does 'clearly' mean?",
  options: [
    "Confusingly",
    "Simply and understandably",
    "Quickly",
    "Loudly"
  ],
  answer: "Simply and understandably"
},
{
  question: "What is the meaning of 'careless'?",
  options: [
    "Careful",
    "Not paying attention",
    "Kind",
    "Strong"
  ],
  answer: "Not paying attention"
},
{
  question: "Choose the correctly punctuated sentence:",
  options: [
    "what is your name",
    "What is your name?",
    "What is your name.",
    "What is your name!"
  ],
  answer: "What is your name?"
},
{
  question: "Choose the correct sentence:",
  options: [
    "My friend kwame is here.",
    "My friend Kwame is here.",
    "My friend kwame Is here.",
    "My friend Kwame is Here."
  ],
  answer: "My friend Kwame is here."
},
{
  question: "Select the correctly punctuated sentence:",
  options: [
    "I like apples oranges and bananas.",
    "I like apples, oranges, and bananas.",
    "I like apples oranges, and bananas.",
    "I like apples, oranges and bananas"
  ],
  answer: "I like apples, oranges, and bananas."
},
{
  question: "Choose the correct sentence:",
  options: [
    "She said I am tired.",
    "She said, I am tired.",
    "She said, 'I am tired.'",
    "She said 'I am tired."
  ],
  answer: "She said, 'I am tired.'"
},
{
  question: "Which sentence is correct?",
  options: [
    "Lets go to school.",
    "Let's go to school.",
    "Lets' go to school.",
    "Let,s go to school."
  ],
  answer: "Let's go to school."
},
{
  question: "Choose the correct punctuation:",
  options: [
    "The boys bag is here.",
    "The boy's bag is here.",
    "The boys' bag is here.",
    "The boy bag's is here."
  ],
  answer: "The boy's bag is here."
},
{
  question: "Select the correct sentence:",
  options: [
    "Wow what a beautiful day",
    "Wow, what a beautiful day!",
    "Wow what a beautiful day!",
    "Wow, what a beautiful day"
  ],
  answer: "Wow, what a beautiful day!"
},
{
  question: "Choose the correct sentence:",
  options: [
    "I will come tomorrow said John.",
    "I will come tomorrow, said John.",
    "'I will come tomorrow,' said John.",
    "I will come tomorrow said, John."
  ],
  answer: "'I will come tomorrow,' said John."
},
{
  question: "Which is correctly punctuated?",
  options: [
    "The book is on the table",
    "The book is on the table.",
    "The book is on the table?",
    "The book is on the table!"
  ],
  answer: "The book is on the table."
},
{
  question: "Choose the correct sentence:",
  options: [
    "She is from ghana.",
    "She is from Ghana.",
    "She is from GHANA.",
    "She is from gHana."
  ],
  answer: "She is from Ghana."
},
{
  question: "Which sentence uses a comma correctly?",
  options: [
    "Before going to school I ate breakfast.",
    "Before going to school, I ate breakfast.",
    "Before going, to school I ate breakfast.",
    "Before going to school I, ate breakfast."
  ],
  answer: "Before going to school, I ate breakfast."
},
{
  question: "Choose the correct punctuation:",
  options: [
    "Whose book is this.",
    "Whose book is this?",
    "Whose book is this!",
    "Whose book is this,"
  ],
  answer: "Whose book is this?"
},
{
  question: "Select the correct sentence:",
  options: [
    "He said that he was coming tomorrow.",
    "He said that, he was coming tomorrow.",
    "He said, that he was coming tomorrow.",
    "He said that he was coming, tomorrow."
  ],
  answer: "He said that he was coming tomorrow."
},
{
  question: "Choose the correct sentence:",
  options: [
    "We visited Accra, Kumasi and Tamale.",
    "We visited Accra Kumasi, and Tamale.",
    "We visited Accra, Kumasi, and Tamale.",
    "We visited Accra Kumasi and Tamale."
  ],
  answer: "We visited Accra, Kumasi, and Tamale."
},
{
  question: "Which is correctly punctuated?",
  options: [
    "He asked where are you going.",
    "He asked, where are you going.",
    "He asked, 'Where are you going?'",
    "He asked where are you going?"
  ],
  answer: "He asked, 'Where are you going?'"
},
{
  question: "Choose the correct sentence:",
  options: [
    "The girls are playing in the field.",
    "the girls are playing in the field.",
    "The girls are Playing in the field.",
    "The girls are playing in the Field."
  ],
  answer: "The girls are playing in the field."
},
{
  question: "Select the correct punctuation:",
  options: [
    "It is a nice day isnt it?",
    "It is a nice day isn't it?",
    "It is a nice day isnt it.",
    "It is a nice day isn't it."
  ],
  answer: "It is a nice day isn't it?"
},
{
  question: "Choose the correct sentence:",
  options: [
    "My fathers car is new.",
    "My father's car is new.",
    "My fathers' car is new.",
    "My father car's is new."
  ],
  answer: "My father's car is new."
},
{
  question: "Which sentence is correct?",
  options: [
    "She said, she was tired.",
    "She said she was tired.",
    "She said, that she was tired.",
    "She said that, she was tired."
  ],
  answer: "She said she was tired."
},
{
  question: "Choose the correct punctuation:",
  options: [
    "Hurry up!",
    "Hurry up.",
    "Hurry up?",
    "Hurry, up!"
  ],
  answer: "Hurry up!"
},
{
  question: "Choose the correct sentence:",
  options: [
    "She has ate the food.",
    "She has eaten the food.",
    "She have eaten the food.",
    "She has eating the food."
  ],
  answer: "She has eaten the food."
},
{
  question: "Fill in the blank: By this time tomorrow, we ____ the journey.",
  options: ["will complete", "will have completed", "completed", "completing"],
  answer: "will have completed"
},
{
  question: "Choose the correct word: He is fond ____ playing football.",
  options: ["of", "on", "in", "at"],
  answer: "of"
},
{
  question: "Which sentence is correct?",
  options: [
    "She is one of the best student.",
    "She is one of the best students.",
    "She is one of the best student�s.",
    "She is one of the best students�."
  ],
  answer: "She is one of the best students."
},
{
  question: "Choose the correct form: If he had studied, he ____ passed.",
  options: ["will have", "would have", "would", "will"],
  answer: "would have"
},
{
  question: "What does the idiom 'kick the bucket' mean?",
  options: [
    "To run fast",
    "To die",
    "To fall down",
    "To fight"
  ],
  answer: "To die"
},
{
  question: "Choose the correct sentence:",
  options: [
    "I look forward to meet you.",
    "I look forward to meeting you.",
    "I look forward meeting you.",
    "I look forward to met you."
  ],
  answer: "I look forward to meeting you."
},
{
  question: "Choose the correct word: She insisted ____ going there.",
  options: ["on", "in", "at", "for"],
  answer: "on"
},
{
  question: "Which sentence is correct?",
  options: [
    "Neither of the boys are here.",
    "Neither of the boys is here.",
    "Neither of the boys were here.",
    "Neither of the boys have been here."
  ],
  answer: "Neither of the boys is here."
},
{
  question: "Choose the correct tense: He ____ here since morning.",
  options: ["has been", "have been", "is being", "was being"],
  answer: "has been"
},
{
  question: "What does the idiom 'spill the beans' mean?",
  options: [
    "To cook food",
    "To reveal a secret",
    "To make noise",
    "To waste time"
  ],
  answer: "To reveal a secret"
},
{
  question: "Choose the correct word: He is capable ____ doing the work.",
  options: ["of", "on", "at", "in"],
  answer: "of"
},
{
  question: "Choose the correct sentence:",
  options: [
    "The teacher, along with the students, are coming.",
    "The teacher, along with the students, is coming.",
    "The teacher along with the students are coming.",
    "The teacher along with the students were coming."
  ],
  answer: "The teacher, along with the students, is coming."
},
{
  question: "Choose the correct form: She would rather ____ at home.",
  options: ["stay", "stays", "staying", "stayed"],
  answer: "stay"
},
{
  question: "What does the idiom 'a piece of cake' mean?",
  options: [
    "Something very difficult",
    "Something very easy",
    "Something sweet",
    "Something expensive"
  ],
  answer: "Something very easy"
},
{
  question: "Choose the correct sentence:",
  options: [
    "He is too weak to lift the box.",
    "He is so weak to lift the box.",
    "He is very weak to lift the box.",
    "He is weak enough to not lift the box."
  ],
  answer: "He is too weak to lift the box."
},
{
  question: "Choose the correct word: She is married ____ a doctor.",
  options: ["to", "with", "on", "at"],
  answer: "to"
},
{
  question: "Choose the correct form: Hardly had he arrived ____ it started raining.",
  options: ["than", "when", "then", "that"],
  answer: "when"
},
{
  question: "What does the idiom 'under the weather' mean?",
  options: [
    "Feeling sick",
    "Feeling happy",
    "Feeling strong",
    "Feeling excited"
  ],
  answer: "Feeling sick"
},
{
  question: "Choose the correct sentence:",
  options: [
    "She is used to live here.",
    "She is used to living here.",
    "She used to living here.",
    "She is use to living here."
  ],
  answer: "She is used to living here."
},
{
  question: "Read: 'Kwame studied every night and avoided distractions. He finally passed his exams with distinction.' What is the main reason for his success?",
  options: [
    "Luck",
    "Hard work and discipline",
    "Help from friends",
    "Easy questions"
  ],
  answer: "Hard work and discipline"
},
{
  question: "From the passage above, what can you infer about Kwame?",
  options: [
    "He is careless",
    "He is determined",
    "He is lazy",
    "He is weak"
  ],
  answer: "He is determined"
},
{
  question: "Read: 'The sky grew dark and the wind became strong. Soon, heavy rain began to fall.' What is happening?",
  options: [
    "A sunny day",
    "A storm is coming",
    "A festival is starting",
    "A journey begins"
  ],
  answer: "A storm is coming"
},
{
  question: "Read: 'Ama always helps her classmates and shares what she has.' What type of person is Ama?",
  options: [
    "Selfish",
    "Generous",
    "Lazy",
    "Angry"
  ],
  answer: "Generous"
},
{
  question: "What is the meaning of 'diligent'?",
  options: [
    "Lazy",
    "Hardworking",
    "Weak",
    "Slow"
  ],
  answer: "Hardworking"
},
{
  question: "Read: 'The man spoke in a harsh tone, making everyone uncomfortable.' What does 'harsh' suggest?",
  options: [
    "Kind",
    "Gentle",
    "Rough and unfriendly",
    "Soft"
  ],
  answer: "Rough and unfriendly"
},
{
  question: "What is the synonym of 'important'?",
  options: ["Trivial", "Significant", "Small", "Minor"],
  answer: "Significant"
},
{
  question: "Read: 'She hesitated before answering the question.' What does 'hesitated' mean?",
  options: [
    "Answered quickly",
    "Paused before acting",
    "Ignored the question",
    "Shouted loudly"
  ],
  answer: "Paused before acting"
},
{
  question: "What is the antonym of 'increase'?",
  options: ["Rise", "Grow", "Decrease", "Expand"],
  answer: "Decrease"
},
{
  question: "Read: 'The teacher praised him for his excellent performance.' What does 'praised' mean?",
  options: [
    "Criticized",
    "Complimented",
    "Ignored",
    "Punished"
  ],
  answer: "Complimented"
},
{
  question: "What is the tone of the sentence: 'You have done very well; keep it up!'?",
  options: [
    "Angry",
    "Encouraging",
    "Sad",
    "Confused"
  ],
  answer: "Encouraging"
},
{
  question: "Read: 'The road was narrow and full of potholes, making the journey difficult.' What made the journey difficult?",
  options: [
    "Traffic",
    "The condition of the road",
    "The weather",
    "The driver"
  ],
  answer: "The condition of the road"
},
{
  question: "What is the meaning of 'fragile'?",
  options: [
    "Strong",
    "Easily broken",
    "Heavy",
    "Hard"
  ],
  answer: "Easily broken"
},
{
  question: "Read: 'He spoke confidently during the presentation.' What does 'confidently' mean?",
  options: [
    "With fear",
    "With doubt",
    "With assurance",
    "With anger"
  ],
  answer: "With assurance"
},
{
  question: "What is the synonym of 'assist'?",
  options: ["Help", "Stop", "Leave", "Ignore"],
  answer: "Help"
},
{
  question: "Read: 'The child clung to his mother out of fear.' What does 'clung' mean?",
  options: [
    "Held tightly",
    "Ran away",
    "Cried loudly",
    "Jumped"
  ],
  answer: "Held tightly"
},
{
  question: "What is the antonym of 'brave'?",
  options: ["Fearless", "Bold", "Cowardly", "Strong"],
  answer: "Cowardly"
},
{
  question: "Read: 'The team celebrated their victory with joy.' What does 'celebrated' mean?",
  options: [
    "Ignored",
    "Rejoiced",
    "Complained",
    "Fought"
  ],
  answer: "Rejoiced"
},
{
  question: "What is the meaning of 'reluctant'?",
  options: [
    "Willing",
    "Unwilling",
    "Happy",
    "Excited"
  ],
  answer: "Unwilling"
},
{
  question: "What is the main idea of a passage?",
  options: [
    "A small detail",
    "The central message",
    "A random sentence",
    "The first line only"
  ],
  answer: "The central message"
},
{
  question: "Which of the following is a feature of a formal letter?",
  options: [
    "Use of slang",
    "Proper address and date",
    "Use of emojis",
    "Short forms"
  ],
  answer: "Proper address and date"
},
{
  question: "Which of the following is appropriate in an informal letter?",
  options: [
    "Strict formal tone",
    "Friendly language",
    "Official titles only",
    "Complex vocabulary only"
  ],
  answer: "Friendly language"
},
{
  question: "What is the main purpose of a letter?",
  options: [
    "To entertain only",
    "To communicate information",
    "To decorate pages",
    "To confuse readers"
  ],
  answer: "To communicate information"
},
{
  question: "Which of the following is the correct salutation for a formal letter?",
  options: [
    "Hi friend",
    "Dear Sir/Madam",
    "Hello buddy",
    "Hey there"
  ],
  answer: "Dear Sir/Madam"
},
{
  question: "Which of the following is used to end a formal letter?",
  options: [
    "Yours faithfully",
    "See you later",
    "Bye",
    "Take care"
  ],
  answer: "Yours faithfully"
},
{
  question: "Which of the following is NOT suitable for a formal letter?",
  options: [
    "Clear language",
    "Slang expressions",
    "Proper format",
    "Correct grammar"
  ],
  answer: "Slang expressions"
},
{
  question: "What is the purpose of a narrative essay?",
  options: [
    "To describe an event",
    "To tell a story",
    "To argue a point",
    "To give instructions"
  ],
  answer: "To tell a story"
},
{
  question: "What is the purpose of a descriptive essay?",
  options: [
    "To argue",
    "To describe in detail",
    "To give orders",
    "To summarize"
  ],
  answer: "To describe in detail"
},
{
  question: "Which of the following is important in essay writing?",
  options: [
    "Poor organization",
    "Clear introduction, body, and conclusion",
    "Slang language",
    "Random ideas"
  ],
  answer: "Clear introduction, body, and conclusion"
},
{
  question: "Which of the following best explains communication?",
  options: [
    "Talking alone",
    "Sharing information between people",
    "Writing only",
    "Listening only"
  ],
  answer: "Sharing information between people"
},
{
  question: "Which of the following is a form of written communication?",
  options: [
    "Speech",
    "Letter",
    "Gesture",
    "Sign language"
  ],
  answer: "Letter"
},
{
  question: "Which of the following is a form of oral communication?",
  options: [
    "Writing",
    "Reading",
    "Speaking",
    "Typing"
  ],
  answer: "Speaking"
},
{
  question: "What is the purpose of communication?",
  options: [
    "To confuse others",
    "To exchange ideas",
    "To waste time",
    "To argue only"
  ],
  answer: "To exchange ideas"
},
{
  question: "Which of the following improves effective communication?",
  options: [
    "Poor listening",
    "Clear expression",
    "Interrupting others",
    "Using unclear words"
  ],
  answer: "Clear expression"
},
{
  question: "Which of the following is an example of non-verbal communication?",
  options: [
    "Writing",
    "Speaking",
    "Gestures",
    "Reading"
  ],
  answer: "Gestures"
},
{
  question: "Which of the following is important when writing an essay?",
  options: [
    "Ignoring grammar",
    "Using correct punctuation",
    "Writing randomly",
    "Using slang"
  ],
  answer: "Using correct punctuation"
},
{
  question: "Which of the following is a key feature of good writing?",
  options: [
    "Unclear ideas",
    "Proper organization",
    "Poor grammar",
    "Incomplete sentences"
  ],
  answer: "Proper organization"
},
{
  question: "Which of the following is important in formal communication?",
  options: [
    "Respectful tone",
    "Casual language",
    "Slang words",
    "Short forms"
  ],
  answer: "Respectful tone"
},
{
  question: "Which of the following is the correct closing for an informal letter?",
  options: [
    "Yours faithfully",
    "Dear Sir",
    "Your friend",
    "Yours obediently"
  ],
  answer: "Your friend"
},
{
  question: "Which of the following best explains listening in communication?",
  options: [
    "Ignoring others",
    "Paying attention to what is said",
    "Talking always",
    "Interrupting speakers"
  ],
  answer: "Paying attention to what is said"
},
{
  question: "Choose the correct sentence:",
  options: [
    "She has wrote the letter.",
    "She has written the letter.",
    "She have written the letter.",
    "She has writing the letter."
  ],
  answer: "She has written the letter."
},
{
  question: "What is the meaning of 'scarce'?",
  options: [
    "Plenty",
    "Rare",
    "Big",
    "Cheap"
  ],
  answer: "Rare"
},
{
  question: "Choose the correct word: I prefer tea ____ coffee.",
  options: ["than", "to", "over", "with"],
  answer: "to"
},
{
  question: "Identify the incorrect sentence:",
  options: [
    "He is going home.",
    "They are playing.",
    "She don't like food.",
    "We are happy."
  ],
  answer: "She don't like food."
},
{
  question: "What does the idiom 'hit the nail on the head' mean?",
  options: [
    "To make a mistake",
    "To be exactly right",
    "To hit something",
    "To build something"
  ],
  answer: "To be exactly right"
},
{
  question: "Choose the correct punctuation:",
  options: [
    "Where are you going.",
    "Where are you going?",
    "Where are you going!",
    "Where are you going,"
  ],
  answer: "Where are you going?"
},
{
  question: "Fill in the blank: If she ____ harder, she would pass.",
  options: ["studies", "studied", "study", "studying"],
  answer: "studied"
},
{
  question: "Choose the synonym of 'assist':",
  options: ["Help", "Stop", "Leave", "Ignore"],
  answer: "Help"
},
{
  question: "Read: 'The boy was trembling because of fear.' What does 'trembling' mean?",
  options: [
    "Laughing",
    "Shaking",
    "Running",
    "Jumping"
  ],
  answer: "Shaking"
},
{
  question: "Choose the correct sentence:",
  options: [
    "Neither of the girls are present.",
    "Neither of the girls is present.",
    "Neither of the girls were present.",
    "Neither of the girls have been present."
  ],
  answer: "Neither of the girls is present."
},
{
  question: "What is the antonym of 'expand'?",
  options: ["Grow", "Increase", "Reduce", "Stretch"],
  answer: "Reduce"
},
{
  question: "Choose the correct word: ____ is your book.",
  options: ["This", "These", "Those", "Them"],
  answer: "This"
},
{
  question: "Which sentence is correct?",
  options: [
    "He is good in English.",
    "He is good at English.",
    "He is good on English.",
    "He is good for English."
  ],
  answer: "He is good at English."
},
{
  question: "What is the main idea of a passage?",
  options: [
    "A small detail",
    "The central message",
    "The last sentence",
    "The first word"
  ],
  answer: "The central message"
},
{
  question: "Choose the correct tense: They ____ to school yesterday.",
  options: ["go", "went", "gone", "going"],
  answer: "went"
},
{
  question: "What does 'optimistic' mean?",
  options: [
    "Hopeful",
    "Sad",
    "Angry",
    "Lazy"
  ],
  answer: "Hopeful"
},
{
  question: "Choose the correct sentence:",
  options: [
    "She is taller than me.",
    "She is more taller than me.",
    "She is tallest than me.",
    "She taller than me."
  ],
  answer: "She is taller than me."
},
{
  question: "Identify the error:",
  options: [
    "I have finished my work.",
    "She has eaten.",
    "They has gone home.",
    "We have seen it."
  ],
  answer: "They has gone home."
},
{
  question: "Choose the correct preposition: He is proud ____ his son.",
  options: ["of", "on", "at", "in"],
  answer: "of"
},
{
  question: "What does the idiom 'once in a blue moon' mean?",
  options: [
    "Very often",
    "Rarely",
    "Always",
    "Never"
  ],
  answer: "Rarely"
},
{
  question: "Choose the correct sentence:",
  options: [
    "She has went to school.",
    "She has gone to school.",
    "She have gone to school.",
    "She has going to school."
  ],
  answer: "She has gone to school."
},
{
  question: "Fill in the blank: By next year, he ____ his studies.",
  options: ["will finish", "will have finished", "finished", "finishing"],
  answer: "will have finished"
},
{
  question: "Choose the correct word: I am not used ____ waking up early.",
  options: ["to", "for", "on", "at"],
  answer: "to"
},
{
  question: "Identify the incorrect sentence:",
  options: [
    "They are coming now.",
    "He is reading.",
    "She do her homework every day.",
    "We are happy."
  ],
  answer: "She do her homework every day."
},
{
  question: "What is the meaning of 'abundant'?",
  options: [
    "Scarce",
    "Plenty",
    "Little",
    "Rare"
  ],
  answer: "Plenty"
},
{
  question: "Choose the correct punctuation:",
  options: [
    "Lets go home.",
    "Let's go home.",
    "Lets' go home.",
    "Let,s go home."
  ],
  answer: "Let's go home."
},
{
  question: "Choose the correct sentence:",
  options: [
    "He is one of the best player.",
    "He is one of the best players.",
    "He is one of the best player's.",
    "He is one of the best players'."
  ],
  answer: "He is one of the best players."
},
{
  question: "What does the idiom 'cost an arm and a leg' mean?",
  options: [
    "Very cheap",
    "Very expensive",
    "Very easy",
    "Very difficult"
  ],
  answer: "Very expensive"
},
{
  question: "Choose the correct word: ____ going to the market.",
  options: ["Their", "There", "They're", "Them"],
  answer: "They're"
},
{
  question: "Which sentence is correct?",
  options: [
    "He is married with her.",
    "He is married to her.",
    "He is married on her.",
    "He is married at her."
  ],
  answer: "He is married to her."
},
{
  question: "Choose the antonym of 'increase':",
  options: ["Grow", "Rise", "Reduce", "Expand"],
  answer: "Reduce"
},
{
  question: "Read: 'The child cried loudly because he was hungry.' Why did the child cry?",
  options: [
    "He was tired",
    "He was hungry",
    "He was angry",
    "He was playing"
  ],
  answer: "He was hungry"
},
{
  question: "Choose the correct tense: She ____ here since morning.",
  options: ["has been", "have been", "is being", "was being"],
  answer: "has been"
},
{
  question: "Choose the correct sentence:",
  options: [
    "He asked where is she going.",
    "He asked where she was going.",
    "He asked where was she going.",
    "He asked where she is going."
  ],
  answer: "He asked where she was going."
},
{
  question: "What is the synonym of 'difficult'?",
  options: ["Easy", "Hard", "Simple", "Light"],
  answer: "Hard"
},
{
  question: "Choose the correct preposition: She is proud ____ her success.",
  options: ["of", "on", "at", "in"],
  answer: "of"
},
{
  question: "Identify the error:",
  options: [
    "She is happy.",
    "They are playing.",
    "He have finished.",
    "We are learning."
  ],
  answer: "He have finished."
},
{
  question: "What does the idiom 'burn the midnight oil' mean?",
  options: [
    "To sleep early",
    "To work late at night",
    "To cook food",
    "To waste time"
  ],
  answer: "To work late at night"
},
{
  question: "Choose the correct word: This is ____ house.",
  options: ["my", "mine", "me", "I"],
  answer: "my"
},
{
  question: "Which of the following improves good writing?",
  options: [
    "Poor grammar",
    "Clear organization",
    "Random ideas",
    "Slang language"
  ],
  answer: "Clear organization"
},
{
  question: "Which word has a different vowel sound?",
  options: ["cat", "bat", "hat", "cart"],
  answer: "cart"
},
{
  question: "Which word has the same vowel sound as 'see'?",
  options: ["sit", "sea", "set", "sat"],
  answer: "sea"
},
{
  question: "Which word is stressed on the first syllable?",
  options: ["beGIN", "aBOVE", "TAble", "reLAX"],
  answer: "TAble"
},
{
  question: "Which word is stressed on the second syllable?",
  options: ["TAble", "DOCtor", "beGIN", "MOney"],
  answer: "beGIN"
},
{
  question: "Choose the correct pronunciation group:",
  options: ["ship/sheep", "cat/cart", "sit/set", "bat/bit"],
  answer: "ship/sheep"
},
{
  question: "Change to passive voice: 'The boy kicked the ball.'",
  options: [
    "The ball kicked the boy.",
    "The ball was kicked by the boy.",
    "The ball is kicked by the boy.",
    "The ball has kicked the boy."
  ],
  answer: "The ball was kicked by the boy."
},
{
  question: "Change to active voice: 'The letter was written by Ama.'",
  options: [
    "Ama writes the letter.",
    "Ama wrote the letter.",
    "Ama writing the letter.",
    "Ama is wrote the letter."
  ],
  answer: "Ama wrote the letter."
},
{
  question: "Choose the correct passive sentence:",
  options: [
    "The food was eat by him.",
    "The food was eaten by him.",
    "The food is ate by him.",
    "The food eaten by him."
  ],
  answer: "The food was eaten by him."
},
{
  question: "Change to indirect speech: He said, 'I am tired.'",
  options: [
    "He said that I am tired.",
    "He said that he was tired.",
    "He said that he is tired.",
    "He said that he tired."
  ],
  answer: "He said that he was tired."
},
{
  question: "Change to indirect speech: She said, 'I will come.'",
  options: [
    "She said that she will come.",
    "She said that she would come.",
    "She said that I would come.",
    "She said that she come."
  ],
  answer: "She said that she would come."
},
{
  question: "Which of the following is a simile?",
  options: [
    "He is a lion.",
    "He is as brave as a lion.",
    "The wind whispered.",
    "Time flies."
  ],
  answer: "He is as brave as a lion."
},
{
  question: "Which of the following is a metaphor?",
  options: [
    "He is as fast as lightning.",
    "He is a lion.",
    "The sun smiled.",
    "The wind howled."
  ],
  answer: "He is a lion."
},
{
  question: "Which of the following is personification?",
  options: [
    "The tree danced in the wind.",
    "He is as tall as a tree.",
    "The tree is tall.",
    "The tree is green."
  ],
  answer: "The tree danced in the wind."
},
{
  question: "Which word is correctly spelled?",
  options: ["definately", "definitely", "definatelye", "definitly"],
  answer: "definitely"
},
{
  question: "Which word is correctly spelled?",
  options: ["seperate", "separate", "seperete", "separrate"],
  answer: "separate"
},
{
  question: "Choose the correct sentence:",
  options: [
    "He said he is coming yesterday.",
    "He said he was coming the previous day.",
    "He said he was coming yesterday.",
    "He said he is coming the previous day."
  ],
  answer: "He said he was coming the previous day."
},
{
  question: "Which of the following is an example of alliteration?",
  options: [
    "She sells sea shells.",
    "He is brave like a lion.",
    "The sun smiled.",
    "Time flies."
  ],
  answer: "She sells sea shells."
},
{
  question: "Which sentence is passive?",
  options: [
    "The teacher taught the lesson.",
    "The lesson was taught by the teacher.",
    "The teacher is teaching.",
    "The teacher teaches well."
  ],
  answer: "The lesson was taught by the teacher."
},
{
  question: "Which sentence is indirect speech?",
  options: [
    "He said, 'I am ready.'",
    "He said that he was ready.",
    "He says, 'I am ready.'",
    "He said, 'I was ready.'"
  ],
  answer: "He said that he was ready."
},
{
  question: "Which of the following best explains stress in English?",
  options: [
    "Writing words",
    "Emphasis on certain syllables",
    "Reading quickly",
    "Speaking loudly"
  ],
  answer: "Emphasis on certain syllables"
},
{
  question: "Fill in the blank: The boy ____ to school every day.",
  options: ["go", "goes", "gone", "going"],
  answer: "goes"
},
{
  question: "Fill in the blank: She ____ her homework before going out.",
  options: ["finish", "finishes", "finished", "finishing"],
  answer: "finished"
},
{
  question: "Fill in the blank: They ____ playing football now.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "Fill in the blank: The teacher ____ teaching when I arrived.",
  options: ["is", "was", "were", "be"],
  answer: "was"
},
{
  question: "Fill in the blank: If he ____ hard, he will pass.",
  options: ["study", "studies", "studied", "studying"],
  answer: "studies"
},
{
  question: "Fill in the blank: She is afraid ____ dogs.",
  options: ["on", "at", "of", "with"],
  answer: "of"
},
{
  question: "Fill in the blank: The book is ____ the table.",
  options: ["on", "in", "at", "by"],
  answer: "on"
},
{
  question: "Fill in the blank: He is interested ____ music.",
  options: ["in", "on", "at", "for"],
  answer: "in"
},
{
  question: "Fill in the blank: We arrived ____ the station early.",
  options: ["on", "in", "at", "by"],
  answer: "at"
},
{
  question: "Fill in the blank: She is good ____ mathematics.",
  options: ["in", "on", "at", "with"],
  answer: "at"
},
{
  question: "Fill in the blank: ____ is raining heavily.",
  options: ["He", "She", "It", "They"],
  answer: "It"
},
{
  question: "Fill in the blank: I saw ____ at the market.",
  options: ["they", "them", "their", "theirs"],
  answer: "them"
},
{
  question: "Fill in the blank: This book is ____.",
  options: ["my", "mine", "me", "I"],
  answer: "mine"
},
{
  question: "Fill in the blank: She is taller ____ her sister.",
  options: ["than", "then", "that", "those"],
  answer: "than"
},
{
  question: "Fill in the blank: He is one of the best ____ in the class.",
  options: ["student", "students", "student's", "students'"],
  answer: "students"
},
{
  question: "Fill in the blank: Neither of the boys ____ present.",
  options: ["is", "are", "were", "have"],
  answer: "is"
},
{
  question: "Fill in the blank: The girl ____ won the prize is my sister.",
  options: ["who", "which", "whom", "whose"],
  answer: "who"
},
{
  question: "Fill in the blank: She ____ to Accra last week.",
  options: ["go", "went", "gone", "going"],
  answer: "went"
},
{
  question: "Fill in the blank: By this time tomorrow, we ____ the work.",
  options: ["finish", "will finish", "will have finished", "finishing"],
  answer: "will have finished"
},
{
  question: "Fill in the blank: He ____ been here since morning.",
  options: ["has", "have", "had", "having"],
  answer: "has"
},
{
  question: "What does 'give up' mean?",
  options: [
    "Continue",
    "Stop trying",
    "Start again",
    "Run away"
  ],
  answer: "Stop trying"
},
{
  question: "What does 'look after' mean?",
  options: [
    "Search for",
    "Take care of",
    "Ignore",
    "Call someone"
  ],
  answer: "Take care of"
},
{
  question: "What does 'turn off' mean?",
  options: [
    "Start something",
    "Stop a machine",
    "Increase speed",
    "Move away"
  ],
  answer: "Stop a machine"
},
{
  question: "What does 'bring up' mean?",
  options: [
    "Raise a child",
    "Destroy something",
    "Hide something",
    "Leave something"
  ],
  answer: "Raise a child"
},
{
  question: "What does 'run into' mean?",
  options: [
    "Avoid someone",
    "Meet by chance",
    "Run fast",
    "Fight someone"
  ],
  answer: "Meet by chance"
},
{
  question: "What does 'put off' mean?",
  options: [
    "Postpone",
    "Complete",
    "Start",
    "Cancel forever"
  ],
  answer: "Postpone"
},
{
  question: "What does 'carry on' mean?",
  options: [
    "Stop working",
    "Continue",
    "Leave",
    "Rest"
  ],
  answer: "Continue"
},
{
  question: "What does 'take off' mean?",
  options: [
    "Remove",
    "Put on",
    "Break",
    "Fix"
  ],
  answer: "Remove"
},
{
  question: "Choose the correct noun form of 'happy':",
  options: ["happiness", "happying", "happily", "happyness"],
  answer: "happiness"
},
{
  question: "Choose the correct noun form of 'decide':",
  options: ["decision", "deciding", "decided", "decide"],
  answer: "decision"
},
{
  question: "Choose the correct noun form of 'create':",
  options: ["creation", "creating", "created", "creates"],
  answer: "creation"
},
{
  question: "Choose the correct adjective form of 'care':",
  options: ["careful", "carefully", "caringly", "care"],
  answer: "careful"
},
{
  question: "Choose the correct adverb form of 'quick':",
  options: ["quick", "quickly", "quicker", "quickness"],
  answer: "quickly"
},
{
  question: "Choose the correct noun form of 'strong':",
  options: ["strength", "strongly", "stronger", "strongness"],
  answer: "strength"
},
{
  question: "Choose the correct adjective form of 'danger':",
  options: ["dangerous", "dangerously", "dangered", "danger"],
  answer: "dangerous"
},
{
  question: "Choose the correct noun form of 'teach':",
  options: ["teacher", "teaching", "taught", "teach"],
  answer: "teacher"
},
{
  question: "Choose the correct adverb form of 'slow':",
  options: ["slow", "slowly", "slowness", "slower"],
  answer: "slowly"
},
{
  question: "Choose the correct noun form of 'move':",
  options: ["movement", "moving", "moved", "moves"],
  answer: "movement"
},
{
  question: "Choose the correct adjective form of 'beauty':",
  options: ["beautiful", "beautifully", "beautify", "beauty"],
  answer: "beautiful"
},
{
  question: "Choose the correct noun form of 'know':",
  options: ["knowledge", "knowing", "known", "knows"],
  answer: "knowledge"
},
{
  question: "Rewrite: 'The boy is too young to drive.'",
  options: [
    "The boy is so young that he can drive.",
    "The boy is so young that he cannot drive.",
    "The boy is very young to drive.",
    "The boy is young and can drive."
  ],
  answer: "The boy is so young that he cannot drive."
},
{
  question: "Rewrite: 'Although it was raining, they played football.'",
  options: [
    "It was raining but they played football.",
    "It was raining so they played football.",
    "It was raining because they played football.",
    "It was raining and they stopped playing."
  ],
  answer: "It was raining but they played football."
},
{
  question: "Choose the correct connective: He was tired, ____ he continued working.",
  options: ["but", "because", "so", "and"],
  answer: "but"
},
{
  question: "Choose the correct connective: She studied hard, ____ she passed the exam.",
  options: ["but", "because", "so", "although"],
  answer: "so"
},
{
  question: "Rewrite: 'He is too weak to carry the load.'",
  options: [
    "He is so weak that he can carry the load.",
    "He is so weak that he cannot carry the load.",
    "He is very weak to carry the load.",
    "He is weak and can carry the load."
  ],
  answer: "He is so weak that he cannot carry the load."
},
{
  question: "Choose the correct connective: ____ it was late, he continued working.",
  options: ["Although", "Because", "So", "And"],
  answer: "Although"
},
{
  question: "Rewrite: 'She is so short that she cannot reach the shelf.'",
  options: [
    "She is too short to reach the shelf.",
    "She is very short to reach the shelf.",
    "She is short and reaches the shelf.",
    "She is short enough to reach the shelf."
  ],
  answer: "She is too short to reach the shelf."
},
{
  question: "Choose the correct connective: He failed the exam ____ he did not study.",
  options: ["but", "because", "so", "although"],
  answer: "because"
},
{
  question: "Rewrite: 'Despite being tired, she finished the work.'",
  options: [
    "Although she was tired, she finished the work.",
    "Because she was tired, she finished the work.",
    "She was tired so she stopped working.",
    "She was tired and did not finish the work."
  ],
  answer: "Although she was tired, she finished the work."
},
{
  question: "Choose the correct connective: I will come ____ you invite me.",
  options: ["if", "but", "because", "so"],
  answer: "if"
},
{
  question: "Rewrite: 'He worked hard so that he could succeed.'",
  options: [
    "He worked hard to succeed.",
    "He worked hard and failed.",
    "He worked hard but did not succeed.",
    "He worked hard because he failed."
  ],
  answer: "He worked hard to succeed."
},
{
  question: "Choose the correct connective: ____ she was sick, she went to school.",
  options: ["Although", "Because", "So", "And"],
  answer: "Although"
},
{
  question: "Rewrite: 'He is too lazy to succeed.'",
  options: [
    "He is so lazy that he cannot succeed.",
    "He is so lazy that he can succeed.",
    "He is lazy and succeeds.",
    "He is very lazy to succeed."
  ],
  answer: "He is so lazy that he cannot succeed."
},
{
  question: "Choose the correct connective: She was hungry ____ she ate food.",
  options: ["but", "so", "although", "because"],
  answer: "so"
},
{
  question: "Rewrite: 'Because he was tired, he slept early.'",
  options: [
    "He was tired so he slept early.",
    "He was tired but he slept early.",
    "He was tired although he slept early.",
    "He was tired and did not sleep."
  ],
  answer: "He was tired so he slept early."
},
{
  question: "Choose the correct connective: He is rich ____ he is not happy.",
  options: ["but", "because", "so", "and"],
  answer: "but"
},
{
  question: "Rewrite: 'She is too young to understand.'",
  options: [
    "She is so young that she cannot understand.",
    "She is so young that she can understand.",
    "She is very young to understand.",
    "She is young and understands."
  ],
  answer: "She is so young that she cannot understand."
},
{
  question: "Choose the correct connective: ____ he tried hard, he failed.",
  options: ["Although", "Because", "So", "And"],
  answer: "Although"
},
{
  question: "Rewrite: 'He ran fast so that he could catch the bus.'",
  options: [
    "He ran fast to catch the bus.",
    "He ran fast and missed the bus.",
    "He ran fast but missed the bus.",
    "He ran fast because he missed the bus."
  ],
  answer: "He ran fast to catch the bus."
},
{
  question: "Choose the correct connective: She was late ____ the traffic was heavy.",
  options: ["because", "but", "so", "although"],
  answer: "because"
},
{
  question: "Rewrite: 'The boy is too young to drive.'",
  options: [
    "The boy is so young that he can drive.",
    "The boy is so young that he cannot drive.",
    "The boy is very young to drive.",
    "The boy is young and can drive."
  ],
  answer: "The boy is so young that he cannot drive."
},
{
  question: "Rewrite: 'Although it was raining, they played football.'",
  options: [
    "It was raining but they played football.",
    "It was raining so they played football.",
    "It was raining because they played football.",
    "It was raining and they stopped playing."
  ],
  answer: "It was raining but they played football."
},
{
  question: "Choose the correct connective: He was tired, ____ he continued working.",
  options: ["but", "because", "so", "and"],
  answer: "but"
},
{
  question: "Choose the correct connective: She studied hard, ____ she passed the exam.",
  options: ["but", "because", "so", "although"],
  answer: "so"
},
{
  question: "Rewrite: 'He is too weak to carry the load.'",
  options: [
    "He is so weak that he can carry the load.",
    "He is so weak that he cannot carry the load.",
    "He is very weak to carry the load.",
    "He is weak and can carry the load."
  ],
  answer: "He is so weak that he cannot carry the load."
},
{
  question: "Choose the correct connective: ____ it was late, he continued working.",
  options: ["Although", "Because", "So", "And"],
  answer: "Although"
},
{
  question: "Rewrite: 'She is so short that she cannot reach the shelf.'",
  options: [
    "She is too short to reach the shelf.",
    "She is very short to reach the shelf.",
    "She is short and reaches the shelf.",
    "She is short enough to reach the shelf."
  ],
  answer: "She is too short to reach the shelf."
},
{
  question: "Choose the correct connective: He failed the exam ____ he did not study.",
  options: ["but", "because", "so", "although"],
  answer: "because"
},
{
  question: "Rewrite: 'Despite being tired, she finished the work.'",
  options: [
    "Although she was tired, she finished the work.",
    "Because she was tired, she finished the work.",
    "She was tired so she stopped working.",
    "She was tired and did not finish the work."
  ],
  answer: "Although she was tired, she finished the work."
},
{
  question: "Choose the correct connective: I will come ____ you invite me.",
  options: ["if", "but", "because", "so"],
  answer: "if"
},
{
  question: "Rewrite: 'He worked hard so that he could succeed.'",
  options: [
    "He worked hard to succeed.",
    "He worked hard and failed.",
    "He worked hard but did not succeed.",
    "He worked hard because he failed."
  ],
  answer: "He worked hard to succeed."
},
{
  question: "Choose the correct connective: ____ she was sick, she went to school.",
  options: ["Although", "Because", "So", "And"],
  answer: "Although"
},
{
  question: "Rewrite: 'He is too lazy to succeed.'",
  options: [
    "He is so lazy that he cannot succeed.",
    "He is so lazy that he can succeed.",
    "He is lazy and succeeds.",
    "He is very lazy to succeed."
  ],
  answer: "He is so lazy that he cannot succeed."
},
{
  question: "Choose the correct connective: She was hungry ____ she ate food.",
  options: ["but", "so", "although", "because"],
  answer: "so"
},
{
  question: "Rewrite: 'Because he was tired, he slept early.'",
  options: [
    "He was tired so he slept early.",
    "He was tired but he slept early.",
    "He was tired although he slept early.",
    "He was tired and did not sleep."
  ],
  answer: "He was tired so he slept early."
},
{
  question: "Choose the correct connective: He is rich ____ he is not happy.",
  options: ["but", "because", "so", "and"],
  answer: "but"
},
{
  question: "Rewrite: 'She is too young to understand.'",
  options: [
    "She is so young that she cannot understand.",
    "She is so young that she can understand.",
    "She is very young to understand.",
    "She is young and understands."
  ],
  answer: "She is so young that she cannot understand."
},
{
  question: "Choose the correct connective: ____ he tried hard, he failed.",
  options: ["Although", "Because", "So", "And"],
  answer: "Although"
},
{
  question: "Rewrite: 'He ran fast so that he could catch the bus.'",
  options: [
    "He ran fast to catch the bus.",
    "He ran fast and missed the bus.",
    "He ran fast but missed the bus.",
    "He ran fast because he missed the bus."
  ],
  answer: "He ran fast to catch the bus."
},
{
  question: "Choose the correct connective: She was late ____ the traffic was heavy.",
  options: ["because", "but", "so", "although"],
  answer: "because"
},
{
  question: "Arrange the sentences to form a meaningful paragraph: (1) He entered the classroom. (2) The bell rang. (3) The students sat quietly. (4) The teacher began the lesson.",
  options: [
    "2,1,3,4",
    "1,2,3,4",
    "3,2,1,4",
    "2,3,1,4"
  ],
  answer: "2,1,3,4"
},
{
  question: "Arrange the sentences correctly: (1) She woke up early. (2) She prepared breakfast. (3) She went to school. (4) She brushed her teeth.",
  options: [
    "1,4,2,3",
    "4,1,2,3",
    "1,2,4,3",
    "2,1,4,3"
  ],
  answer: "1,4,2,3"
},
{
  question: "Arrange the sentences: (1) The rain started. (2) We ran inside. (3) The sky became dark. (4) We were playing outside.",
  options: [
    "4,3,1,2",
    "3,4,1,2",
    "4,1,3,2",
    "1,4,3,2"
  ],
  answer: "4,3,1,2"
},
{
  question: "Arrange correctly: (1) He studied hard. (2) He passed the exam. (3) He was happy. (4) He received his results.",
  options: [
    "1,4,2,3",
    "4,1,2,3",
    "1,2,4,3",
    "2,1,4,3"
  ],
  answer: "1,4,2,3"
},
{
  question: "Arrange: (1) The teacher entered. (2) The class stood up. (3) The lesson began. (4) The students greeted.",
  options: [
    "1,2,4,3",
    "2,1,4,3",
    "1,4,2,3",
    "2,4,1,3"
  ],
  answer: "1,2,4,3"
},
{
  question: "Which of the following is the correct format for a formal letter?",
  options: [
    "Address, date, salutation, body, closing",
    "Body, address, closing, date",
    "Date, body, address, closing",
    "Salutation, body, address, date"
  ],
  answer: "Address, date, salutation, body, closing"
},
{
  question: "Which of the following is appropriate in a complaint letter?",
  options: [
    "Rude language",
    "Clear and polite expression",
    "Slang words",
    "Jokes"
  ],
  answer: "Clear and polite expression"
},
{
  question: "What is the purpose of an application letter?",
  options: [
    "To complain",
    "To apply for a position",
    "To tell a story",
    "To invite someone"
  ],
  answer: "To apply for a position"
},
{
  question: "Which of the following should be included in a notice?",
  options: [
    "Clear information",
    "Long stories",
    "Unclear message",
    "Slang"
  ],
  answer: "Clear information"
},
{
  question: "Which of the following is important in writing a report?",
  options: [
    "Facts and clarity",
    "Jokes",
    "Slang",
    "Random ideas"
  ],
  answer: "Facts and clarity"
},
{
  question: "What is the purpose of a notice?",
  options: [
    "To entertain",
    "To inform the public",
    "To tell stories",
    "To confuse readers"
  ],
  answer: "To inform the public"
},
{
  question: "Which of the following is NOT part of a formal letter?",
  options: [
    "Address",
    "Date",
    "Slang expressions",
    "Signature"
  ],
  answer: "Slang expressions"
},
{
  question: "Which of the following is important in communication?",
  options: [
    "Clarity",
    "Confusion",
    "Silence",
    "Interruptions"
  ],
  answer: "Clarity"
},
{
  question: "Which of the following best explains effective writing?",
  options: [
    "Clear and organized ideas",
    "Random sentences",
    "Poor grammar",
    "Unclear meaning"
  ],
  answer: "Clear and organized ideas"
},
{
  question: "Which of the following improves communication?",
  options: [
    "Listening carefully",
    "Interrupting",
    "Ignoring others",
    "Speaking loudly only"
  ],
  answer: "Listening carefully"
},
{
  question: "Which of the following is a feature of good paragraph writing?",
  options: [
    "One main idea",
    "Many unrelated ideas",
    "No structure",
    "Random words"
  ],
  answer: "One main idea"
},
{
  question: "Which of the following is important in letter writing?",
  options: [
    "Correct format",
    "Slang",
    "Poor grammar",
    "Unclear ideas"
  ],
  answer: "Correct format"
},
{
  question: "Which of the following is a feature of a good notice?",
  options: [
    "Brief and clear",
    "Long and confusing",
    "Full of jokes",
    "Unclear message"
  ],
  answer: "Brief and clear"
},
{
  question: "Which of the following is important in writing essays?",
  options: [
    "Introduction, body, conclusion",
    "Only introduction",
    "Only conclusion",
    "Random ideas"
  ],
  answer: "Introduction, body, conclusion"
},
{
  question: "Which of the following is essential in communication?",
  options: [
    "Understanding",
    "Confusion",
    "Silence",
    "Noise"
  ],
  answer: "Understanding"
},

  
  {
    question: "Buy is the opposite of:",
    options: ["Sell", "Give", "Own", "Pay"],
    answer: "Sell"
  }
];
export default jhsenglishLanguageQuestions;